import { render, staticRenderFns } from "./AC_AIM_Detail.vue?vue&type=template&id=4f7265f5&scoped=true"
import script from "./AC_AIM_Detail.vue?vue&type=script&lang=js"
export * from "./AC_AIM_Detail.vue?vue&type=script&lang=js"
import style0 from "./AC_AIM_Detail.vue?vue&type=style&index=0&id=4f7265f5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7265f5",
  null
  
)

export default component.exports